'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var BlueTextButton = require('../../../buttons/BlueTextButton/BlueTextButton.js');
var styledComponents = require('./styled-components.js');
var ConversationSnackBar = require('./components/ConversationSnackBar.js');

var PollingSpeed = 10000; // speed of polling responses (10 seconds)
var usePrevious = function (value) {
    var ref = React.useRef(0);
    React.useEffect(function () {
        if (value)
            ref.current = value;
    });
    return ref.current;
};
var useDeltaValue = function (val) {
    var previousVal = usePrevious(val);
    return val - previousVal;
};
var ConversationScrollContainer = function (props) {
    var messages = props.messages, getMore = props.getMore, pollForMore = props.pollForMore, _a = props.pollSpeed, pollSpeed = _a === void 0 ? PollingSpeed : _a, _b = props.maximumResponseLength, maximumResponseLength = _b === void 0 ? 20 : _b;
    // STATE
    var _c = React.useState(false), snackBarOpen = _c[0], setSnackBarOpen = _c[1];
    var _d = React.useState(false), allMessagesRetrieved = _d[0], setAllMessagesRetrieved = _d[1];
    var _e = React.useState(false), loadingMessages = _e[0], setLoadingMessages = _e[1];
    var _f = React.useState(0), height = _f[0], setHeight = _f[1];
    var _g = React.useState(0), scroll = _g[0], setScroll = _g[1];
    var heightChange = useDeltaValue(height);
    var scrollChange = useDeltaValue(scroll);
    var mainRef = React.useRef(null);
    var scrollToBottom = function () {
        if (mainRef && mainRef.current && mainRef.current.scrollTo) {
            mainRef.current.scrollTo({ top: mainRef.current.scrollHeight, left: 0, behavior: 'smooth' });
        }
    };
    var listener = function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            if (!mainRef || !mainRef.current) {
                return [2 /*return*/];
            }
            if (mainRef && mainRef.current) {
                setScroll(mainRef.current.scrollTop);
            }
            return [2 /*return*/];
        });
    }); };
    var getNewMessages = React.useCallback(function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var isComplete;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMore().catch(function () { return false; })];
                case 1:
                    isComplete = _a.sent();
                    if (isComplete) {
                        setAllMessagesRetrieved(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [getMore]);
    React.useEffect(function () {
        if (scroll < 10 && scrollChange < 0 && scrollChange > -300) {
            setSnackBarOpen(false);
            if (!loadingMessages && !allMessagesRetrieved) {
                setLoadingMessages(true);
                var isComplete_1 = setTimeout(function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
                    return tslib.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getNewMessages()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }, 300);
                setLoadingMessages(false);
                return function () {
                    clearTimeout(isComplete_1);
                };
            }
        }
        return function () { return undefined; };
    }, [scroll, loadingMessages, allMessagesRetrieved, scrollChange, getNewMessages]);
    React.useEffect(function () {
        var current = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current;
        if (current)
            current.addEventListener('scroll', listener);
        return function () {
            if (current)
                current.removeEventListener('scroll', listener);
        };
    }, []);
    React.useEffect(function () {
        // if the TOTAL messages are less than or equal to the maximumResponseLength then its the first request
        if (messages.length <= maximumResponseLength) {
            scrollToBottom();
        }
    }, [messages]);
    var handleCloseSnackBar = function () {
        setSnackBarOpen(false);
    };
    var handleSnackBarButtonClick = function () {
        handleCloseSnackBar();
        scrollToBottom();
    };
    var adjustScrollPosition = React.useCallback(function () {
        if (mainRef && mainRef.current) {
            if (heightChange !== 0 && snackBarOpen) {
                mainRef.current.scrollTo({ top: mainRef.current.scrollTop - heightChange, left: 0 });
            }
            if (heightChange !== 0 && !snackBarOpen) {
                mainRef.current.scrollTo({ top: mainRef.current.scrollTop + heightChange, left: 0 });
            }
        }
    }, [heightChange, snackBarOpen]);
    React.useEffect(function () {
        adjustScrollPosition();
    }, [adjustScrollPosition]);
    var poll = function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
        var isNewMessage;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, pollForMore().catch(function () {
                        return false;
                    })];
                case 1:
                    isNewMessage = _a.sent();
                    if (isNewMessage) {
                        if (mainRef && mainRef.current) {
                            if (mainRef.current.scrollHeight - mainRef.current.scrollTop < window.innerHeight) {
                                scrollToBottom();
                                return [2 /*return*/];
                            }
                        }
                        if (!snackBarOpen) {
                            setSnackBarOpen(true);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (mainRef && mainRef.current) {
            setHeight(mainRef.current.scrollHeight);
        }
        var pollTimer = setInterval(function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, poll()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, pollSpeed);
        return function () {
            clearInterval(pollTimer);
        };
    }, [poll]);
    return (React__default.createElement(styledComponents.MainDiv, { ref: mainRef, id: 'message_container' },
        React__default.createElement(ConversationSnackBar, { open: snackBarOpen, onClose: handleCloseSnackBar, message: React__default.createElement(BlueTextButton, { title: 'New Message(s)!', onClick: handleSnackBarButtonClick }) }),
        React__default.createElement(styledComponents.MainUL, null, messages.map(function (child, i) {
            return (React__default.createElement("li", { style: { minHeight: '10px', marginTop: '10px' }, key: "child" + (messages.length - (i + 1)) }, child));
        }))));
};

module.exports = ConversationScrollContainer;
